<template>
    <div>
        <v-btn class="primary" @click="readDocument()" v-if="canRead">{{ buttonText }}</v-btn>
        <p class="font-weight-medium" v-if="operationUuidMsg">El uuid de la operación es un campo obligatorio para rechazar la operación.</p>
        <p class="font-weight-medium" v-if="documentUuidMsg">El id del documento es un campo obligatorio para rechazar la operación.</p>
        <p id="snackbar-success"></p>
        <p id="snackbar-error"></p>
    </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    token: String,
    endPointReadDocument: String,
    endPointSignOtp: String,
    operationUuid: String,
    documentUuid: String,
    domainUuid: String,
    cellPhone: String,
    buttonText: String,
    status: {
      type: Number,
      default: 0
    },
    response: {
      type: String,
      default: ""
    },
    loading: Boolean,
    snackBar: Boolean,
    successMsg: String,
    errorMsgReadDocument: String,
    errorMsgSignOTP: String
  },
  data() {
    return {
      data: {},
      canRead: true,
      domainidUuidMsg: false,
      operationUuidMsg: false,
      documentUuidMsg: false
      // ,
      // successAttachDoc: "El documento ha sido aportado",
      // errorAttachDoc: "Ha ocurrido un error al aportar el documento"
    };
  },
  created() {
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.documentUuidMsg =
      (typeof this.documentUuid === "undefined" || this.documentUuid === "") ===
      true;
    if (this.operationUuidMsg === true || this.domainidUuidMsg === true) {
      this.canRead = false;
    }
  },
  methods: {
    readDocument() {
      this.data.operationUuid = this.operationUuid;
      this.data.documentUuid = this.documentUuid;
      axios.defaults.headers.common.Authorization = this.token;
      if (this.loading) {
        this.showLoading();
      }
      this.EventBus.$emit("notifyReadDocumentSignOTP", "showLoading");
      axios
        .post(`${this.endPointReadDocument}${this.operationUuid}`, this.data, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            this.getSignOTP();
          },
          responseError => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-error", this.errorMsgReadDocument);
            }
            this.EventBus.$emit("notifyReadDocumentSignOTP", "hideLoading");
          }
        );
    },
    getSignOTP() {
      this.data.operationUuid = this.operationUuid;
      this.data.cellPhone = this.cellPhone;
      // this.data.domainid = this.domainid;
      this.data.otpType = "FIRMA";
      axios
        .post(`${this.endPointSignOtp}${this.operationUuid}`, this.data, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-success", this.successMsg);
            }
            this.EventBus.$emit("notifyReadDocumentSignOTP", "hideLoading");
            this.EventBus.$emit("successReadDocumentSignOTP");
          },
          responseError => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-error", this.errorMsgSignOTP);
            }
            this.EventBus.$emit("notifyReadDocumentSignOTP", "hideLoading");
            this.EventBus.$emit("errorReadDocumentSignOTP");
          }
        );
    }
  }
};
</script>
